import React from "react";
import Navbar from "../components/Navbar";
import { useTranslation, Trans } from "react-i18next";
import Seo from "../components/Seo";

const CancellationPolicy = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const isMobile = () =>
    window.matchMedia && window.matchMedia("(max-width: 480px)").matches;

  const pageStyle = {
    backgroundColor: "#1C1C17",
    color: "white",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  };

  const contentStyle = {
    maxWidth: "800px",
    width: "100%",
    margin: "0 auto",
    padding: "20px",
    boxSizing: "border-box",
  };

  const titleContainerStyle = {
    textAlign: "center",
    padding: isMobile() ? "90px 0 20px" : "90px 0 40px",
  };

  const titleStyle = {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  const lastUpdatedStyle = {
    fontSize: "0.9rem",
    opacity: "0.7",
  };

  const subtitleStyle = {
    fontSize: "1.8rem",
    fontWeight: "bold",
    marginTop: "30px",
    marginBottom: "15px",
  };

  const textStyle = {
    fontSize: "1rem",
    lineHeight: "1.6",
    marginBottom: "15px",
  };

  const listStyle = {
    paddingLeft: isRTL ? "0" : "18px",
    paddingRight: isRTL ? "15px" : "0",
    marginBottom: "15px",
  };

  const linkStyle = {
    color: "#4DA8DA",
    textDecoration: "none",
  };

  const renderList = (translationKey) =>
    t(translationKey, { returnObjects: true }).map((item) => (
      <li key={item}>{item}</li>
    ));

  const renderParagraphs = (translationKey) =>
    t(translationKey, { returnObjects: true }).map((item) => (
      <p key={item} style={textStyle}>
        {item}
      </p>
    ));

  return (
    <div style={pageStyle}>
      <Seo
        title="Refunds and Cancellations | Nightly"
        description="Read Nightly's refunds and cancellations policy for purchases made through Nightly."
        path="/cancellation-policy"
      />
      <Navbar />
      <div style={contentStyle}>
        <div style={titleContainerStyle}>
          <h1 style={titleStyle}>{t("cancellation_policy.title")}</h1>
          <p style={lastUpdatedStyle}>
            {t("cancellation_policy.last_updated")}
          </p>
        </div>

        <p style={textStyle}>{t("cancellation_policy.introduction_text")}</p>

        <h2 style={subtitleStyle}>{t("cancellation_policy.scope_title")}</h2>
        <p style={textStyle}>{t("cancellation_policy.scope_text")}</p>

        <h2 style={subtitleStyle}>
          {t("cancellation_policy.request_title")}
        </h2>
        <p style={textStyle}>
          <Trans
            i18nKey="cancellation_policy.request_text"
            components={{
              email: (
                <a
                  href="mailto:support@nightly.co?subject=Cancellation%20Request%20-%20Nightly"
                  style={linkStyle}
                >
                  support@nightly.co
                </a>
              ),
            }}
          />
        </p>
        <ul style={listStyle}>
          {renderList("cancellation_policy.request_list")}
        </ul>

        <h2 style={subtitleStyle}>
          {t("cancellation_policy.remote_sale_title")}
        </h2>
        <p style={textStyle}>{t("cancellation_policy.remote_sale_text")}</p>
        <ul style={listStyle}>
          {renderList("cancellation_policy.remote_sale_list")}
        </ul>

        <h2 style={subtitleStyle}>{t("cancellation_policy.refund_title")}</h2>
        <p style={textStyle}>{t("cancellation_policy.refund_text")}</p>
        <ul style={listStyle}>
          {renderList("cancellation_policy.refund_list")}
        </ul>

        <h2 style={subtitleStyle}>
          {t("cancellation_policy.exceptions_title")}
        </h2>
        <p style={textStyle}>{t("cancellation_policy.exceptions_text")}</p>
        <p style={textStyle}>
          {t("cancellation_policy.exceptions_additional_text")}
        </p>
        <ul style={listStyle}>
          {renderList("cancellation_policy.exceptions_list")}
        </ul>

        <h2 style={subtitleStyle}>{t("cancellation_policy.event_title")}</h2>
        {renderParagraphs("cancellation_policy.event_paragraphs")}

        <h2 style={subtitleStyle}>{t("cancellation_policy.contact_title")}</h2>
        <p style={textStyle}>
          <Trans
            i18nKey="cancellation_policy.contact_text"
            components={{
              email: (
                <a href="mailto:support@nightly.co" style={linkStyle}>
                  support@nightly.co
                </a>
              ),
            }}
          />
        </p>

        <h2 style={subtitleStyle}>{t("cancellation_policy.dispute_title")}</h2>
        <p style={textStyle}>{t("cancellation_policy.dispute_text")}</p>
        <p style={textStyle}>
          <Trans
            i18nKey="cancellation_policy.dispute_contact_text"
            components={{
              email: (
                <a href="mailto:support@nightly.co" style={linkStyle}>
                  support@nightly.co
                </a>
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
};

export default CancellationPolicy;
